// DS: i2.19
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const Folder: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16">
        <path
          fill="currentColor"
          d="M1.5 3.49h7.03l-.82-.99A1.42 1.42 0 0 0 6.6 2H2.89c-.36 0-.7.12-.96.36s-.42.58-.43.93zm13 2.06c0-.41-.36-.75-.81-.75H2.3c-.45 0-.81.34-.81.75v7.7c0 .41.36.75.81.75h11.4c.45 0 .81-.34.81-.75v-7.7Z"
        ></path>
      </svg>
    </IconWrap>
  );
};
Folder.displayName = 'Folder';

export default Folder;
